<template>
    <div class="popup popup-about" :class="popupClass" :style="{'display': popupDisplay}">
        <div class="js-smartScroll" style="position: relative; width: 100%; height: 100%; top: 0; left: 0; overflow: scroll;">
            <div class="content-block ">
                <img :src="suiteImage" id="suiteModalImg" style="width: 100%;">
            </div>
        </div>
        <a @click="goBack" class="close-popup" style="position: absolute; display: block;top: 5px;right: 15px;width: 50px;height: 50px;text-align: right; ">X</a>
    </div>
</template>

<script>
export default {
    name: 'StateroomSuitePopup',
    props: {
        suiteImage: {
            type: String
        },
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    data() {
      return {
        popupClass: '',
        popupDisplay: 'none'
      }
    },
    watch: {
      isShow(val) {
        this.popupDisplay = val ? "block" : "none";
        setTimeout(()=> {
          this.popupClass = val ? 'modal-in' : 'modal-out';
        },100);
      }
    },
    methods: {
        goBack () {
            this.popupClass = '';
            this.onGoBack()
        },
        showStyle () {
            return { }
        }
    }
}
</script>

<style lang="less" scoped>
.popup {
    position: fixed;
}
</style>